import { ARTIST_NAME, LOGO } from "@/data/site";

// Her eye/crown/crystals symbol + the "JENNROCK" logotype (the same one on
// her album cover, supplied as a white-on-transparent PNG).
export const Wordmark = ({ size = "md", showSymbol = true, className = "" }) => {
  const word = { sm: "h-4", md: "h-5", lg: "h-8" }[size];
  const sym = { sm: "h-7", md: "h-9", lg: "h-14" }[size];
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      {showSymbol && (
        <img
          src={LOGO.symbol}
          alt=""
          aria-hidden
          className={`${sym} w-auto object-contain`}
          style={{ filter: "drop-shadow(0 0 8px rgba(255, 46, 151, 0.45))" }}
        />
      )}
      <img src={LOGO.wordmark} alt={ARTIST_NAME} className={`${word} w-auto object-contain`} />
    </span>
  );
};
